import { render, staticRenderFns } from "./UI.vue?vue&type=template&id=983f34d2&scoped=true&"
import script from "./UI.vue?vue&type=script&lang=js&"
export * from "./UI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983f34d2",
  null
  
)

export default component.exports